import { Checkbox } from "@arco-design/web-react";
import deleteImg from "@/assets/cut-mix-detail/white_delete.png";
import "./CoverImgCard.less";
import YulanImg from "@/assets/cut-mix-detail/yulan.png";
interface ICoverImgOrMp3Card {
  id: number;
  style?: React.CSSProperties;
  isChecked: boolean;
  name: string;
  img: string;
  handleCheckStateChange: (e: boolean) => void;
  handleDeleteBtnClick?: (id: number) => void;
  handleLookBtnClick?: () => void;
  onDragStart?: (e: React.DragEvent<HTMLDivElement>) => void;
  showLookBtn?: boolean;
}

const CoverImgCard: React.FC<ICoverImgOrMp3Card> = (props) => {
  const {
    isChecked,
    handleCheckStateChange,
    style,
    id,
    img,
    name,
    handleDeleteBtnClick,
    handleLookBtnClick,
    onDragStart,
    showLookBtn
  } = props;
  return (
    <div
      style={style}
      className={`${isChecked ? "active" : ""} cover-card-wrapper `}>
      <img
        className="cover-img"
        src={img}
        alt=""
        onClick={() => {
          handleCheckStateChange(!isChecked);
        }}
      />
      <div className="checkbox-wrapper">
        <Checkbox
          style={{ width: 14, height: 14 }}
          checked={isChecked}
          onChange={(e) => {
            handleCheckStateChange(e);
          }}></Checkbox>
      </div>
      {
        showLookBtn && <div className="look_wrapper">
              <img
                  src={YulanImg}
                  alt=""
                  onClick={() => {
                    if (handleLookBtnClick) {
                      handleLookBtnClick();
                    }
                  }}
              />
          </div>
      }
      <div className="delete_wrapper">
        <img
          src={deleteImg}
          alt=""
          onClick={() => {
            if (handleDeleteBtnClick) {
              handleDeleteBtnClick(id);
            }
          }}
        />
      </div>
      <p>{name}</p>
    </div>
  );
};

export default CoverImgCard;
